import { render } from "./musica_fondo.vue?vue&type=template&id=20c67545&scoped=true"
import script from "./musica_fondo.vue?vue&type=script&lang=js"
export * from "./musica_fondo.vue?vue&type=script&lang=js"

import "./musica_fondo.vue?vue&type=style&index=0&id=20c67545&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c67545"]])

export default __exports__